<template>
    <FullscreenModal :on-close="close" :is-open="isOpen" :title="$t('pay.add')">
        <template v-slot:body>
            <v-card-text class="mt-4">
                <div class="mt-4">
                    <InfoBox :icon="icons.heart">
                        <template v-slot:text>
                            <span v-html="infoText ? infoText : $t('pay.help_text_modal')"></span>
                            <div class="mt-4">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <a v-on="on">{{ $t("pay.why") }}</a>
                                    </template>
                                    <span v-html="$t('pay.why_hint')"></span>
                                </v-tooltip>
                            </div>
                        </template>
                    </InfoBox>
                </div>
                <div v-if="provider === 'payment_center'">
                    <PaymentCenterOrder
                        :user-id="user.id"
                        :on-success="paymentSuccess"
                        :on-decline="paymentDecline"
                        :on-cancel="paymentDecline"
                    ></PaymentCenterOrder>
                </div>
                <div v-if="provider === 'fondy'" class="mt-6">
                    <FondyOrder
                        :user-id="user.id"
                        :on-success="paymentSuccess"
                        :on-decline="paymentDecline"
                        :on-cancel="paymentDecline"
                    ></FondyOrder>
                </div>
                <div class="pay-info mt-2">
                    <a @click="showPaymentInfo = !showPaymentInfo">{{ $t("pay.more_info") }}</a>
                    <v-expand-transition>
                        <p v-if="showPaymentInfo">
                            {{ $t("pay.info", { host }) }}
                        </p>
                    </v-expand-transition>
                </div>
            </v-card-text>
        </template>
    </FullscreenModal>
</template>

<script>
import InfoBox from "@/app/mobile/ui/InfoBox";
import FondyOrder from "@/app/shared/components/app-payments/FondyOrder";
import PaymentCenterOrder from "@/app/shared/components/app-payments/PaymentCenterOrder";
import FullscreenModal from "@/app/mobile/ui/FullscreenModal";
import heart from "@/assets/img/icon-heart.png";
import { PanelNotifications } from "@/app/shared/services";
import AxiosClient from "../../../../shared/services/http-client/axios";

export default {
    name: "PaymentCenterModal",
    props: ["infoText"],
    components: { FullscreenModal, InfoBox, PaymentCenterOrder, FondyOrder },
    data() {
        return {
            showPaymentInfo: false,
            icons: { heart },
            host: window.location.hostname,
            provider: undefined,
        };
    },
    created() {
        this.getPaymentProvider();
    },
    computed: {
        user() {
            return this.$store.getters.AUTH_USER;
        },
        isOpen() {
            return this.$store.getters.IS_PAYMENTS_MODAL_OPENED;
        },
    },
    methods: {
        getPaymentProvider() {
            AxiosClient.get("/payment/payment-provider").then((response) => {
                this.provider = response.data.provider;
            });
        },
        paymentSuccess() {
            this.$toast.success(this.$t("pay.success"));
            this.$store.dispatch("GET_AUTH_USER");
            this.$store.dispatch("OPEN_PAYMENTS_MODAL", false);
            PanelNotifications.noCreditCard.close();
        },
        paymentDecline() {
            this.$toast.error(this.$t("pay.decline"));
        },
        close() {
            this.$store.dispatch("OPEN_PAYMENTS_MODAL", false);
        },
    },
};
</script>

<style>
.pay-info {
    padding: 0 20px;
}
.pay-info a {
    font-size: 11px !important;
    text-align: center;
}

.pay-info p {
    font-size: 11px;
    line-height: 1.5;
    text-align: justify;
    color: #bbbbbb;
}
</style>
